export default [
    {
        name: '__component:ks-keys-drag-drop',
        width: '32px',
        defaultSearch: false,
        useInFilter: false,
    },
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },

    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'frequency',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'isgeo',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: 'isquest',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: '__slot:keys_meta',
        dataClass: 'text-center',
        defaultSearch: false,
        useInFilter: false,
    },

]
